import React, { useEffect, useState } from "react";
import { HeartPulse } from "lucide-react";
import { api } from "@/lib/api";

export default function Services() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="services-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-green">Hospital Services</span>
          <h1 className="text-4xl sm:text-5xl font-bold">Care that covers every need.</h1>
        </div>
      </section>
      <section className="container-x py-10 grid sm:grid-cols-2 md:grid-cols-3 gap-5">
        {items.map((s) => (
          <div key={s.id} className="card-clean p-6" data-testid={`service-${s.id}`}>
            <div className="h-12 w-12 rounded-xl bg-brand-green/15 text-brand-green grid place-items-center mb-3"><HeartPulse className="h-6 w-6" /></div>
            <div className="font-semibold text-lg">{s.name}</div>
            <p className="text-sm text-slate-600 mt-2">{s.description}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
